/**
 * CertBadges – Zertifizierungs-Badges für psychologisch wichtige Stellen.
 * Design: Einheitlich, keine grellen Plattform-Farben, CI-konform.
 */

interface CertBadgesProps {
  bgColor?: string;
  showLabel?: boolean;
  compact?: boolean;
  className?: string;
}

const BADGES = [
  {
    platform: "Google Ads",
    short: "Google Ads",
    src: "/manus-storage/01_google_ads_badge_9677b3d8.svg",
  },
  {
    platform: "Meta Ads",
    short: "Meta Ads",
    src: "/manus-storage/02_meta_ads_badge_f7ef5eb4.svg",
  },
  {
    platform: "Google Analytics",
    short: "Google Analytics",
    src: "/manus-storage/03_google_analytics_badge_1459b157.svg",
  },
  {
    platform: "SISTRIX",
    short: "SISTRIX",
    src: "/manus-storage/04_sistrix_badge_547376b6.svg",
  },
  {
    platform: "SEMrush",
    short: "SEMrush",
    src: "/manus-storage/05_semrush_badge_f76f01e0.svg",
  },
];

export function CertBadges({
  bgColor = "transparent",
  showLabel = false,
  compact = false,
  className = "",
}: CertBadgesProps) {
  const isDark =
    bgColor !== "transparent" &&
    bgColor !== "#ffffff" &&
    bgColor !== "#fff" &&
    bgColor !== "#f2f2f2" &&
    bgColor !== "white";

  if (compact) {
    // Kompakter Modus: einzeilige Trust-Leiste, einheitlich ohne grelle Farben
    return (
      <div className={`flex flex-col gap-1.5 ${className}`}>
        {showLabel && (
          <p
            style={{
              color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.3)",
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: "0.18em",
              fontSize: "0.58rem",
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            Zertifizierte Expertin
          </p>
        )}
        <div className="flex items-center gap-2 flex-wrap">
          {BADGES.map((badge) => (
            <div
              key={badge.platform}
              className="flex items-center gap-1.5"
              style={{
                background: "#ffffff",
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: 4,
                padding: "3px 8px 3px 4px",
                boxShadow: isDark ? "0 1px 4px rgba(0,0,0,0.4)" : "0 1px 3px rgba(0,0,0,0.08)",
              }}
            >
              <img
                src={badge.src}
                alt={badge.platform}
                style={{
                  width: 22,
                  height: 16,
                  objectFit: "contain",
                  display: "block",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: "0.6rem",
                  fontWeight: 700,
                  color: "#1a1a1a",
                  fontFamily: "'DM Sans', sans-serif",
                  letterSpacing: "0.02em",
                  whiteSpace: "nowrap",
                }}
              >
                {badge.short}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Standard-Modus: einheitliche Badges ohne grelle Plattform-Farben
  return (
    <div
      className={`flex flex-col items-center gap-3 ${className}`}
      style={{ background: bgColor === "transparent" ? undefined : bgColor }}
    >
      {showLabel && (
        <p
          className="text-xs font-black uppercase tracking-widest"
          style={{
            color: isDark ? "rgba(255,255,255,0.6)" : "#6d0000",
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: "0.18em",
          }}
        >
          Zertifizierte Expertin
        </p>
      )}
      <div className="flex items-center justify-center gap-2 flex-wrap">
        {BADGES.map((badge) => (
          <div
            key={badge.platform}
            className="flex items-center gap-2"
            style={{
              background: "#ffffff",
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: 6,
              padding: "5px 10px 5px 8px",
              boxShadow: isDark
                ? "0 1px 6px rgba(0,0,0,0.25)"
                : "0 1px 4px rgba(0,0,0,0.08)",
              minWidth: 0,
            }}
          >
            {/* Logo */}
            <div
              style={{
                width: 28,
                height: 20,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={badge.src}
                alt={badge.platform}
                style={{
                  width: 28,
                  height: 20,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
            {/* Text */}
            <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <span
                style={{
                  fontSize: "0.68rem",
                  fontWeight: 800,
                  color: "#1a1a1a",
                  fontFamily: "'DM Sans', sans-serif",
                  letterSpacing: "0.03em",
                  lineHeight: 1.1,
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                }}
              >
                {badge.platform}
              </span>
              <span
                style={{
                  fontSize: "0.54rem",
                  fontWeight: 600,
                  color: "#9ca3af",
                  fontFamily: "'DM Sans', sans-serif",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  lineHeight: 1,
                }}
              >
                Zertifiziert
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
